module.exports = __webpack_public_path__ + "img/shiyanshi-1.6e40de63.jpg";